import { useEffect, useState } from "react";
import { fetchMarkup } from "../helpers";
import {
  carruselHoteles,
  TituloCarruselDeHoteles,
} from "../services/carruselesService";
import { Row } from "react-bootstrap";
import Slider from "react-slick";
import { settings } from "../utils";
import { CardCarrousel } from "./CardCarrousel";
/**Styles */
import "../styles/hotel.scss";
export const CarruselHotels = ({ idSeccion, idTitulo }) => {
  const [markup, setMarkup] = useState("");
  const today = new Date();
  const [hotels, setHotels] = useState([]);
  const [title, setTitle] = useState();
  const [totalNights, setTotalNights] = useState(0);
  const [dates] = useState([
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 15)
      .toISOString()
      .split("T")[0],
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 17)
      .toISOString()
      .split("T")[0],
  ]);
  useEffect(() => {
    const fetchMarkupPanel = async () => {
      try {
        const markupData = await fetchMarkup("hoteleria");
        setMarkup(markupData?.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanel();
  }, []);

  useEffect(() => {
    const fetchCarruselHoteles = async () => {
      const response = await carruselHoteles(idSeccion);
      return response;
    };
    const fetchHoteles = async () => {
      const response = await fetchCarruselHoteles();
      setHotels(response);
    };
    fetchHoteles();
  }, [idSeccion]);

  useEffect(() => {
    // Obtener la URL actual

    // Obtener las fechas de entrada y salida de la URL
    const checkInDate = dates?.[0];
    const checkOutDate = dates?.[1];

    if (checkInDate && checkOutDate) {
      const checkIn = new Date(checkInDate);
      const checkOut = new Date(checkOutDate);
      const timeDifference = checkOut - checkIn;
      const nights = timeDifference / (1000 * 3600 * 24);

      setTotalNights(nights);
    }
  }, [dates]);

  useEffect(() => {
    const fetchTitleCarruselHotel = async () => {
      try {
        const response = await TituloCarruselDeHoteles();
        setTitle(response);
      } catch (error) {
        throw new Error("Error with the title hotel" + error);
      }
    };
    fetchTitleCarruselHotel();
  }, []);
  return (
    <>
      <div className="d-flex justify-content-between py-0 py-sm-2 py-lg-0 align-items-center mb-4">
        <h3 className="text-lg-start text-center fw-bold title-home pb-3 mb-4 border-1 border-black border-bottom hotel-ideal">
          {title?.[idTitulo].titulo}
        </h3>
        <h5
          className="title-home d-lg-flex d-none text-start"
          style={{ fontSize: "25px", width: "30rem" }}
        >
          {title?.[idTitulo].subtitulo}
        </h5>
      </div>
      <Row className="cards-sliders d-flex justify-content-center">
        {hotels.length > 0 ? (
          <Slider {...settings} className="hotels-slider">
            {hotels.map((dataHotel, index) => {
              return (
                <div className="d-flex justify-content-center" key={index + 1}>
                  <CardCarrousel
                    markup={markup}
                    nights={totalNights}
                    selectedDates={dates}
                    seccion={"dinamicHotels"}
                    dataInfo={dataHotel}
                  />
                </div>
              );
            })}
          </Slider>
        ) : (
          <h1 className="text-center">No hay hoteles disponibles</h1>
        )}
      </Row>
    </>
  );
};
